import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref } from "vue";
const _hoisted_1 = ["src"];
import { computed } from 'vue';
import { useMediaQuery } from '@vueuse/core';
import NaemLogo from './naem-logo.vue';
import HfLogo from '@/components/logo/hf-logo.vue';
import HelpLink from '@/components/help-link/help-link.vue';
import { trlMessage } from '@/services/i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login-layout',
    props: {
        theme: {},
        showSupport: { type: Boolean, default: true }
    },
    setup(__props) {
        const isMobile = useMediaQuery('(max-width: 767px)');
        const heroArtwork = computed(() => isMobile.value && __props.theme.heroMobileArtwork ? __props.theme.heroMobileArtwork : __props.theme.heroArtwork);
        const panelStyle = computed(() => isMobile.value && __props.theme.variant === 'event'
            ? { backgroundImage: `url(${heroArtwork.value})` }
            : undefined);
        const communityArtworkStyle = computed(() => ({
            backgroundImage: `url(${__props.theme.heroOverlayArtwork})`
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.$style.root)
            }, [
                _createElementVNode("header", {
                    class: _normalizeClass(_ctx.$style.mobileHeader)
                }, [
                    _createVNode(HfLogo, {
                        class: _normalizeClass(_ctx.$style.mobileLogo)
                    }, null, 8, ["class"]),
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style.mobileHeaderAction)
                    }, [
                        _renderSlot(_ctx.$slots, "header-action")
                    ], 2)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass([
                        _ctx.$style.hero,
                        __props.theme.variant === 'event' && _ctx.$style.eventHero,
                        __props.theme.heroOverlayArtwork && _ctx.$style.communityHero
                    ]),
                    style: _normalizeStyle(__props.theme.heroOverlayArtwork ? undefined : { backgroundImage: `url(${heroArtwork.value})` })
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style.heroWrapper)
                    }, [
                        (__props.theme.heroLogo === 'naem')
                            ? (_openBlock(), _createBlock(NaemLogo, {
                                key: 0,
                                class: _normalizeClass(_ctx.$style.heroLogo)
                            }, null, 8, ["class"]))
                            : (__props.theme.heroTitle)
                                ? (_openBlock(), _createElementBlock("h1", {
                                    key: 1,
                                    class: _normalizeClass(_ctx.$style.heroTitle)
                                }, _toDisplayString(__props.theme.heroTitle), 3))
                                : _createCommentVNode("", true),
                        (__props.theme.heroSubtitle)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 2,
                                class: _normalizeClass(_ctx.$style.heroSubtitle)
                            }, _toDisplayString(__props.theme.heroSubtitle), 3))
                            : _createCommentVNode("", true)
                    ], 2),
                    (__props.theme.heroOverlayArtwork)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(_ctx.$style.communityArtwork),
                            style: _normalizeStyle(communityArtworkStyle.value),
                            "aria-hidden": "true"
                        }, [
                            _createElementVNode("img", {
                                class: _normalizeClass(_ctx.$style.communityFaces),
                                src: __props.theme.heroArtwork,
                                alt: ""
                            }, null, 10, _hoisted_1)
                        ], 6))
                        : _createCommentVNode("", true)
                ], 6),
                _createElementVNode("main", {
                    class: _normalizeClass([_ctx.$style.panel, __props.theme.variant === 'event' && _ctx.$style.eventPanel]),
                    style: _normalizeStyle(panelStyle.value)
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style.panelInner)
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style.brand)
                        }, [
                            _createVNode(HfLogo, {
                                class: _normalizeClass(_ctx.$style.logo)
                            }, null, 8, ["class"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style.formContent)
                        }, [
                            _renderSlot(_ctx.$slots, "default")
                        ], 2),
                        (__props.showSupport)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(_ctx.$style.support)
                            }, [
                                _createElementVNode("span", null, _toDisplayString(_unref(trlMessage)('login.support')), 1),
                                _createVNode(HelpLink, {
                                    email: "events@huntflow.ru",
                                    label: "events@huntflow.ru"
                                })
                            ], 2))
                            : _createCommentVNode("", true)
                    ], 2)
                ], 6)
            ], 2));
        };
    }
});
